import template from './report_list.html';

class ReportListViewModel
{
	constructor (page)
	{
		this.page = page;
		this.report_pages = ko.observableArray([]);
		this.available_groups = ko.observableArray([]);
		this.selected_group = ko.observable('');
		this.cached_selected_group = ko.observable();
		
		this.session_id = Grape.currentSession.session_id?.substring(23, 29);
	}

	async get_report_page_definitions ()
	{
		let group_value = this.cached_selected_group();
		if ((!group_value) || group_value == 'Choose Group')
			group_value = null;

		let request_obj = {
			schema: 'reports',
			table: 'report_page',
			filter: [{ field: 'active', operand: '=', value: 'true' }]
			
		};
		let result = await Grape.fetches.getJSON('/api/record', request_obj);
		if (result.status === 'ERROR'){
			Grape.alerts.alert({
				type: 'error',
				message: result.message,
				title: 'Error'
			});
		}
		if (result.records && (result.records != null))
			this.report_pages(result.records);
	}

	row_click (report_page)
	{
		let url = ['/reports/report_page', report_page.report_page_id].join('/');
		Grape.navigate(url);
	}

	btn_help_click ()
	{
		Grape.show_dialog('HelpDialog', '/reports/help/report_menu_help.html', {});
	}
}

class ReportListPage 
{
	constructor (bindings, element)
	{
		this.bindings = bindings;
		this.element = element;
		this.viewModel = new ReportListViewModel(this);
		this.name = 'ReportListPage';
		this.has_data = false;
	}

	init ()
	{
		this.viewModel.cached_selected_group(
			sessionStorage.getItem( this.session_id + '_selected_group') || 'Choose Group' );
	}

	async updateData ()
	{
		let available_groups = [];


		let result = await Grape.fetches.getJSON('/api/report/definition/groups', {'active': true});
		if (result.status !== 'ERROR')
		{
			if (result.records && (result.records != null)) {
				for (let group of result.records){
					if (available_groups.indexOf(group.group) == -1)
						available_groups.push(group.group);
				}
				available_groups.unshift('Choose Group');
			
				this.viewModel.available_groups(available_groups);
				this.viewModel.selected_group(this.viewModel.cached_selected_group());
				this.has_data = true;
			}
		}
		else{
			Grape.alerts.alert({
				type: 'error',
				message: 'Could not find Report Group info.',
				title: 'Error'
			});
		}

		this.viewModel.get_report_page_definitions();
	}
}

export default {
	route: '[/]report_list',
	page_class: ReportListPage,
	template: template,
	page_id: '[/]reports',
	title: 'Reports',
	icon: 'fa fa-file-chart-column',
	idx: 10
};
